import { formatDiffValue } from "../lib/content-state";

export type DiffField = {
  field: string;
  draft: unknown;
  published: unknown;
  changed: boolean;
};

type Props = {
  fields: DiffField[];
  hasPublishedSnapshot: boolean;
  publishedVersion: number | null;
  state: string;
};

export function ContentDiffPanel({
  fields,
  hasPublishedSnapshot,
  publishedVersion,
  state,
}: Props) {
  return (
    <div className="content-diff">
      <p className="announcement-list__meta">
        وضعیت فعلی: {state}
        {hasPublishedSnapshot ? (
          <>
            {" · "}
            نسخهٔ منتشرشده:{" "}
            <bdi dir="ltr" className="ltr-isolate latin-digits">
              {publishedVersion}
            </bdi>
          </>
        ) : (
          <> · هنوز نسخه‌ای منتشر نشده</>
        )}
      </p>
      <div className="content-diff__table-wrap">
        <table className="content-diff__table">
          <thead>
            <tr>
              <th>فیلد</th>
              <th>پیش‌نویس / فعلی</th>
              <th>آخرین انتشار</th>
            </tr>
          </thead>
          <tbody>
            {fields.map((row) => (
              <tr key={row.field} className={row.changed ? "content-diff__row--changed" : undefined}>
                <td>
                  <bdi dir="ltr" className="ltr-isolate">
                    {row.field}
                  </bdi>
                </td>
                <td>{formatDiffValue(row.draft)}</td>
                <td>{formatDiffValue(row.published)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
